import styled from "styled-components"

import {Card, Hr} from "@irati/ui/src/Layout"
import {twoPxShadow} from "@irati/ui/src/global/elevation"
import {H4} from "@irati/ui/src//Typography/Heading"
import {RouterLink} from "@irati/ui/src/Link"
import {perkbox} from "@irati/ui/src/global/colors"
import {Label} from "@irati/ui/src/Typography"

interface ColorProps {
  color: string,
  hoverColor?: string
}

export const StyledCard = styled(Card)`
  padding: 20px;
  ${twoPxShadow};
  margin-bottom: 30px;
`
export const StyledHr = styled(Hr)`
  margin: 0;
`
export const StyledHeading = styled(H4)`
  padding-bottom: 0;
`

export const FlexWrapper = styled.span`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
`

export const StyledRouterLink = styled(RouterLink)`
  :hover {
    text-decoration: none;
  }
  margin-right: 20px;
  ${({isActive}) =>
    isActive &&
    `
    box-shadow: 0 3px 0 0 ${perkbox.blue};
  `}
`

export const BalanceContainer = styled.div`
  display: flex;
`

export const Circle = styled.span<ColorProps>`
  height: 37px;
  width: 37px;
  position: relative;
  background-color: ${({color}) => color};
  border-radius: 50%;
  display: inline-block;
  &:hover {
    background-color: ${({theme}) => theme.colors.greys.white};
  }
`

export const FlexCard = styled(Card)<ColorProps>`
  flex-grow: 1;
  width: 0;
  cursor: pointer;
  background-color: ${({color}) => color};
  &:hover {
    background-color: ${({hoverColor}) => hoverColor};
    ${Label} {
      color: ${({theme}) => theme.colors.greys.white};
    }
    ${Circle} {
      background-color: ${({theme}) => theme.colors.greys.white};
    }
  }
`
